import type { ReactElement, ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { AuthPageLoading } from "@/components/layout/AuthPageShell";
import { AuthLoadError } from "@/components/shared/AuthLoadError";
import { useAuth } from "@/hooks/useAuth";
import { resolvePostAuthRoute } from "@/lib/authRouting";

type RequireNoOrgAccessProps = {
  children: ReactNode;
};

export function RequireNoOrgAccess({ children }: RequireNoOrgAccessProps): ReactElement {
  const { user, isLoading, isError, refetch } = useAuth();

  if (isLoading) return <AuthPageLoading />;

  if (isError) return <AuthLoadError onRetry={refetch} />;

  if (!user) return <Navigate to="/login" replace />;
  if (user.organization || user.canOnboard || user.needsPlatformInviteAccept) {
    return <Navigate to={resolvePostAuthRoute(user)} replace />;
  }

  return <>{children}</>;
}
